import { ReactNode } from 'react';
import styled from '@emotion/styled';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import { gray01, gray05, white } from 'presentations/views/styles/color';
import {
  fontSize,
  fontWeight,
  spacing,
  zIndex,
} from 'presentations/views/styles';

export interface Props {
  value: number;
  onChange: (event: any, value: number) => void;
  items: BottomNavigationItem[];
}

interface BottomNavigationItem {
  label: string;
  icon: ReactNode;
}

export default function Component(props: Props) {
  return (
    <Container>
      <BottomNavigation
        showLabels
        value={props.value}
        onChange={props.onChange}
      >
        {props.items.map((item) => (
          <BottomNavigationAction
            label={item.label}
            icon={item.icon}
            key={item.label}
          />
        ))}
      </BottomNavigation>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid ${gray05};
  background-color: ${white};
  z-index: ${zIndex(1100)};

  .MuiBottomNavigation-root {
    /* height: 48px; */
    height: 56px;
  }

  .MuiBottomNavigationAction-root {
    padding: 6px 12px 10px;
  }
  .MuiBottomNavigationAction-wrapper {
    justify-content: space-between;
    height: 100%;
  }

  .MuiBottomNavigationAction-label,
  .MuiBottomNavigationAction-label.Mui-selected {
    font-size: ${fontSize(10)};
    font-weight: ${fontWeight('bold')};
    color: ${gray01};
    margin-top: 2px;
    line-height: 1;
  }
`;
